/* Lemuria Mega Header — interaktivita
   - Click "Obchod" → toggle wide secondary bar
   - Click category in bar → position sub-dropdown under that text
   - Hover-preview: when bar is open, hover on category opens its sub
   - Esc / click outside / click another category → close
   - Mobile burger → drawer
*/
(function() {
  if (window.__lmhInit) return;
  window.__lmhInit = true;

  function init() {
    const root = document.getElementById('lmh');
    if (!root) return;

    const obchodBar = root.querySelector('#lmh-obchod');
    const obchodBtn = root.querySelector('[data-lmh-toggle="obchod"]');
    const backdrop = root.querySelector('.lmh__backdrop');
    const burger = root.querySelectorAll('[data-lmh-burger]');
    const drawer = root.querySelector('.lmh__drawer');
    const subBtns = root.querySelectorAll('[data-lmh-sub]');
    const subPanels = root.querySelectorAll('.lmh__sub');

    // ===== Helper: close all subs
    function closeAllSubs() {
      subPanels.forEach(p => p.dataset.open = 'false');
      subBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
    }

    // ===== Close obchod bar
    function closeObchod() {
      obchodBar.dataset.open = 'false';
      obchodBar.setAttribute('aria-hidden', 'true');
      obchodBtn.setAttribute('aria-expanded', 'false');
      backdrop.dataset.open = 'false';
      closeAllSubs();
    }

    // ===== Open obchod bar
    function openObchod() {
      obchodBar.dataset.open = 'true';
      obchodBar.setAttribute('aria-hidden', 'false');
      obchodBtn.setAttribute('aria-expanded', 'true');
      backdrop.dataset.open = 'true';
    }

    // ===== Open sub for given key
    function openSub(key, anchorBtn) {
      closeAllSubs();
      const panel = root.querySelector('#lmh-sub-' + key);
      if (!panel) return;

      // Position: align panel left edge with anchor button left edge, but constrain to viewport
      requestAnimationFrame(() => {
        const anchorRect = anchorBtn.getBoundingClientRect();
        const barRect = obchodBar.getBoundingClientRect();
        const panelWidth = Math.max(panel.offsetWidth, 240);

        let leftPos = anchorRect.left - barRect.left;
        // Constrain within bar bounds with 24px padding
        const maxLeft = barRect.width - panelWidth - 24;
        if (leftPos > maxLeft) leftPos = maxLeft;
        if (leftPos < 24) leftPos = 24;

        panel.style.left = leftPos + 'px';
        panel.dataset.open = 'true';
        anchorBtn.setAttribute('aria-expanded', 'true');
      });
    }

    // ===== Obchod link: 300ms intent debounce on hover, click navigates
    // Per design brief: 300ms debounce prevents accidental opens on quick mouse passes.
    let obchodOpenTimer;
    if (obchodBtn) {
      obchodBtn.addEventListener('mouseenter', function() {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(obchodOpenTimer);
        // 300ms intent debounce — only open if user lingers
        obchodOpenTimer = setTimeout(() => {
          openObchod();
        }, 300);
      });
      obchodBtn.addEventListener('mouseleave', function() {
        // Cancel pending open if user moves away before 300ms
        clearTimeout(obchodOpenTimer);
      });

      // Touch: tap toggles instead of navigating (per brief touch fallback)
      obchodBtn.addEventListener('click', function(e) {
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          e.stopPropagation();
          if (obchodBar.dataset.open === 'true') closeObchod();
          else openObchod();
        }
      });
    }

    // ===== Hover lock geometry: 150ms close delay on mouseleave of entire header block
    // Per brief: timer cancels if mouse re-enters within 150ms (anti-twitch).
    const headerEl = root;
    let leaveTimer;
    if (headerEl) {
      headerEl.addEventListener('mouseleave', function() {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(() => {
          closeObchod();
        }, 150);
      });
      headerEl.addEventListener('mouseenter', function() {
        clearTimeout(leaveTimer);
      });
    }

    // ===== Categories: 0ms instant sub-dropdown on hover (user already in shopping mode)
    subBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        if (window.matchMedia('(hover: none)').matches) {
          // Touch: first tap shows dropdown, second navigates (per brief)
          const key = this.getAttribute('data-lmh-sub');
          const subEl = root.querySelector('#lmh-sub-' + key);
          if (subEl) {
            const isOpen = subEl.dataset.open === 'true';
            if (!isOpen) {
              e.preventDefault();
              e.stopPropagation();
              openSub(key, this);
            }
            // else allow navigation
          }
        }
        // Desktop: just navigate (default link behavior)
      });

      btn.addEventListener('mouseenter', function() {
        if (window.matchMedia('(hover: none)').matches) return;
        if (obchodBar.dataset.open !== 'true') return;
        // Per brief: 0ms instant — user is already scanning, no debounce needed
        openSub(this.getAttribute('data-lmh-sub'), this);
        // Close any open L4 grand panels in other subs
        closeAllGrand();
      });
    });

    // ===== L4 Grand panels — sub-link wraps with grandchildren
    const grandWraps = root.querySelectorAll('.lmh__sub-link-wrap');
    let grandLeaveTimer;

    function closeAllGrand() {
      grandWraps.forEach(w => {
        w.dataset.open = 'false';
        const link = w.querySelector('.lmh__sub-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    grandWraps.forEach(wrap => {
      wrap.addEventListener('mouseenter', function() {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(grandLeaveTimer);
        // Close other grand panels in same parent sub
        const parentSub = wrap.closest('.lmh__sub');
        if (parentSub) {
          parentSub.querySelectorAll('.lmh__sub-link-wrap').forEach(w => {
            if (w !== wrap) {
              w.dataset.open = 'false';
              const l = w.querySelector('.lmh__sub-link');
              if (l) l.setAttribute('aria-expanded', 'false');
            }
          });
        }
        // Open this one
        wrap.dataset.open = 'true';
        const link = wrap.querySelector('.lmh__sub-link');
        if (link) link.setAttribute('aria-expanded', 'true');
      });
      wrap.addEventListener('mouseleave', function() {
        if (window.matchMedia('(hover: none)').matches) return;
        grandLeaveTimer = setTimeout(() => {
          wrap.dataset.open = 'false';
          const link = wrap.querySelector('.lmh__sub-link');
          if (link) link.setAttribute('aria-expanded', 'false');
        }, 150);
      });
      // Touch: first tap opens grand, second tap navigates
      const linkInner = wrap.querySelector('.lmh__sub-link[data-has-grand="true"]');
      if (linkInner) {
        linkInner.addEventListener('click', function(e) {
          if (window.matchMedia('(hover: none)').matches) {
            const isOpen = wrap.dataset.open === 'true';
            if (!isOpen) {
              e.preventDefault();
              e.stopPropagation();
              wrap.dataset.open = 'true';
              linkInner.setAttribute('aria-expanded', 'true');
            }
          }
        });
      }
    });

    // Also close grand panels when closing obchod bar
    const _origCloseObchod = closeObchod;
    closeObchod = function() {
      _origCloseObchod();
      closeAllGrand();
    };

    // ===== Click outside / on other area to close
    document.addEventListener('click', function(e) {
      // Ignore if clicking inside the header
      if (e.target.closest('#lmh') && !e.target.closest('.lmh__backdrop')) {
        // Inside header but not on backdrop — only close if clicking on links inside dropdowns
        if (e.target.closest('.lmh__sub-link')) {
          // Allow link to navigate
          return;
        }
        return;
      }
      closeObchod();
    });

    // Backdrop click → close
    if (backdrop) backdrop.addEventListener('click', closeObchod);

    // ===== Esc key → close + return focus to Obchod (per brief a11y)
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const wasOpen = obchodBar.dataset.open === 'true';
        closeObchod();
        closeDrawer();
        if (wasOpen && obchodBtn) obchodBtn.focus();
      }
    });

    // ===== Mobile drawer
    function openDrawer() {
      if (drawer) {
        drawer.dataset.open = 'true';
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lmh-no-scroll');
      }
    }
    function closeDrawer() {
      if (drawer) {
        drawer.dataset.open = 'false';
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lmh-no-scroll');
      }
    }
    burger.forEach(b => {
      b.addEventListener('click', function(e) {
        e.stopPropagation();
        if (drawer.dataset.open === 'true') closeDrawer();
        else openDrawer();
      });
    });

    // ===== Update cart count when items change
    document.addEventListener('cart:refresh', function(e) {
      const count = e.detail?.item_count;
      if (count !== undefined) {
        const els = document.querySelectorAll('[data-cart-count]');
        els.forEach(el => {
          el.textContent = count;
          el.style.display = count > 0 ? '' : 'none';
        });
      }
    });

    // ===== Smooth scroll for "Prekvapenie" → randomizer
    const prekvapenie = root.querySelector('[data-lmh-prekvapenie]');
    if (prekvapenie) {
      prekvapenie.addEventListener('click', function(e) {
        const url = this.getAttribute('href');
        if (url.startsWith('/#') || url.startsWith('#')) {
          // We're on homepage if pathname is /
          if (window.location.pathname === '/' || window.location.pathname === '') {
            e.preventDefault();
            const target = document.getElementById('nahodny-produkt');
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
          // else navigate normally to /#nahodny-produkt
        }
      });
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
